import context from '../context'
import getComponentKey from '@/utils/getComponentKey'
import { allowErrorDialog } from '@/utils/fetch'

const initialState = {
  settings: {
    numberOfDaysBeforeDueDate: 0
  },
  fetching: false,
  updating: false,
  componentKey: getComponentKey()
}

export const actionTypes = {
  fetching: 'settings/fetching',
  fetched: 'settings/fetched',
  updating: 'settings/updating',
  updated: 'settings/updated',
  error: 'settings/error'
}

export const actionCreators = {

  get: () => (dispatch) => {
    dispatch({ type: actionTypes.fetching })
    context.api.settingsService.get(allowErrorDialog)
      .then(response => {
        dispatch({ type: actionTypes.fetched, data: response })
      })
      .catch(() => dispatch({ type: actionTypes.error, update: { fetching: false } }))
  },
  save: (input) => (dispatch) => {
    dispatch({ type: actionTypes.updating, data: input })
    context.api.settingsService.save(input, allowErrorDialog)
      .then(response => {
        dispatch({ type: actionTypes.updated, data: input })
      })
      .catch(() => dispatch({ type: actionTypes.error, update: { updating: false } }))
  },
  getWhitelistSettings: () => (dispatch) => {
    dispatch({ type: actionTypes.fetching })
    return context.api.settingsService.getWhitelistSettings(allowErrorDialog)
      .then(response => {
        dispatch({ type: actionTypes.fetched, data: response })
        return response
      })
      .catch(() => {
        dispatch({ type: actionTypes.error, update: { fetching: false } })
        throw new Error('Fetching whitelist failed')
      })
  }
}

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.fetching: return { ...state, fetching: true }
    case actionTypes.fetched: return { ...state, fetching: false, settings: action.data, componentKey: getComponentKey() }
    case actionTypes.updating: return { ...state, updating: true, settings: action.data }
    case actionTypes.updated: return { ...state, updating: false, componentKey: getComponentKey() }
    case actionTypes.error: return { ...state, ...action.update }

    default: return state
  }
}



// WEBPACK FOOTER //
// ./src/store/settings.js